import React from 'react';
import { RadioButtonGroup } from '@lmt/unicorn-shared/app/components/common/ui-kit/RadioButtonGroup';

import styles from './UIEditorBlocks.module.scss';
import { Field } from '../../../common/Field';

export enum UIEditorBlockWidth {
  Sixth = '16.6%',
  Fifth = '20%',
  Quarter = '25%',
  Third = '33%',
  Half = '50%',
  TwoThirds = '66%',
  Stretch = '100%',
}

interface Option {
  value: UIEditorBlockWidth;
  displayValue: string;
}

const blockWidths: Option[] = [
  {
    value: UIEditorBlockWidth.Sixth,
    displayValue: '1/6',
  },
  {
    value: UIEditorBlockWidth.Fifth,
    displayValue: '1/5',
  },
  {
    value: UIEditorBlockWidth.Quarter,
    displayValue: '1/4',
  },
  {
    value: UIEditorBlockWidth.Third,
    displayValue: '1/3',
  },
  {
    value: UIEditorBlockWidth.Half,
    displayValue: '1/2',
  },
  {
    value: UIEditorBlockWidth.TwoThirds,
    displayValue: '2/3',
  },
  {
    value: UIEditorBlockWidth.Stretch,
    displayValue: 'Full width',
  },
];

type BlockProps = {
  size: UIEditorBlockWidth;
};
export type Props = {
  props: BlockProps;
  setProp?: (func: (props: BlockProps) => void) => void;
  setState?: (props: BlockProps) => void;
};

export const WidthSelectControl: React.FC<Props> = ({
  setProp,
  props,
  setState,
}: Props) => {
  return (
    <div style={{ paddingTop: '16px' }}>
      <Field title={'Width'}>
        <RadioButtonGroup<Option, 'value'>
          labelField="displayValue"
          valueField="value"
          options={blockWidths}
          value={props.size}
          required={true}
          onSelectedOptionChanged={(option) => {
            setProp
              ? setProp((props) => (props.size = option!.value))
              : setState && setState({ ...props, size: option!.value });
          }}
          radioButtonClassName={styles.radioButton}
        />
      </Field>
    </div>
  );
};
